import { create } from 'zustand';
import { applyNodeChanges, applyEdgeChanges, addEdge } from '@xyflow/react';

let idCounter = 1;
export const nextNodeId = (prefix = 'n') => `${prefix}_${Date.now().toString(36)}_${idCounter++}`;

export const useGraphStore = create((set, get) => ({
  nodes: [],
  edges: [],
  selectedId: null,
  dirty: false,

  setGraph: (graph) => set({
    nodes: graph?.nodes || [],
    edges: graph?.edges || [],
    dirty: false,
  }),

  getGraphJson: () => ({ version: 1, nodes: get().nodes, edges: get().edges }),

  onNodesChange: (changes) => set({ nodes: applyNodeChanges(changes, get().nodes), dirty: true }),
  onEdgesChange: (changes) => set({ edges: applyEdgeChanges(changes, get().edges), dirty: true }),
  onConnect: (conn) => set({ edges: addEdge({ ...conn, animated: true }, get().edges), dirty: true }),

  addNode: (node) => set({ nodes: [...get().nodes, node], dirty: true }),

  updateNodeData: (id, data) => set({
    nodes: get().nodes.map((n) => (n.id === id ? { ...n, data: { ...n.data, ...data } } : n)),
    dirty: true,
  }),

  removeNode: (id) => set({
    nodes: get().nodes.filter((n) => n.id !== id),
    edges: get().edges.filter((e) => e.source !== id && e.target !== id),
    selectedId: null,
    dirty: true,
  }),

  setSelected: (id) => set({ selectedId: id }),
  markClean: () => set({ dirty: false }),
}));
